import type { SearchCategory } from '@bulknutrients/bulk-shared-lib/interfaces/Category';
import { TrimText as textTrim } from '@bulknutrients/bulk-shared-lib/utils';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { ReactElement } from 'react';

export function SearchResultCardCategory({
  hit,
}: {
  hit: SearchCategory;
}): ReactElement {
  return (
    <div className="py-=2.5 flex flex-col gap-1 border-0 border-b border-solid border-grey-light px-0">
      <TextLink
        href={hit.slug}
        data-umami-event-location="Search Result Card Category Heading"
      >
        <span className="text-lg">{hit.title}</span>
      </TextLink>
      <span>{hit.shortDescription && textTrim(hit.shortDescription, 248)}</span>
    </div>
  );
}
